define('GameDayCore/GDModel/ValueObjects/Players/PlayerCardSplits',['require','exports','module','../ValueObjectFactory','extant/extant'],function(require, exports, module) {
    var VO = require('../ValueObjectFactory'),
        exists = require("extant/extant");

    VO.create(PlayerCardSplits);

    /**
     * Class PlayerCardSplits
     * @param data {Object} passed down from the player card VO
     *
     * VO to provide safe values for all data possible in the player splits file
     */
    function PlayerCardSplits($data) {
        var vo = VO.ensureVO(this, PlayerCardSplits),
            data = $data;

        vo.name = data._nodeName || "";
        vo.label = (exists(data._nodeName)) ? data._nodeName.split("_").join(" ") : "";
        vo.ab = data.ab || "";
        vo.avg = data.avg || "";
        vo.hr = data.hr || "";
        vo.rbi = data.rbi || "";
        vo.ops = data.ops || "";
        vo.bb = data.bb || "";
        vo.so = data.so || "";
        vo.des = data.des || "";
        vo.loves = data.loves || "";
        vo.hates = data.hates || "";
        vo.out = data.out || "";
        vo.w = data.w || "";
        vo.l = data.l || "";
        vo.sv = data.sv || "";
        vo.h = data.h || "";
        vo.ip = data.ip || "";
        vo.whip = data.whip || "";
        vo.era = data.era || "";
        vo.sb = data.sb || "";
        vo.cs = data.cs || "";
    }

    return PlayerCardSplits;
});


